import clsx from "clsx";
import { CloseIcon } from "@/shared/assets/svg/icons";
import "./selected-tag.scss";

interface SelectedTagProps {
  label: string;
  onRemove?: () => void;
  className?: string;
}

export const SelectedTag = ({ label, onRemove, className }: SelectedTagProps) => (
  <span className={clsx("selected-tag", className)}>
    <span className="selected-tag__label">{label}</span>

    {onRemove && (
      <button
        type="button"
        className="selected-tag__remove"
        aria-label="Удалить"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          onRemove();
        }}
      >
        <CloseIcon />
      </button>
    )}
  </span>
);
